module.exports = __webpack_public_path__ + "static/img/C4D0039.0c6da77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0039.jpg
// module id = Fq+6
// module chunks = 0